import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
  GET_CATEGORIES_MINIMALIST,
  actionGetCategoriesMinimalListSuccess,
} from './categories_actions';
import SharedRepository from '../../data/repositories/shared_repository';
import { AbstractCategory } from '../../data/types/categories';
import { shouldRefreshCache } from '../../utils/functions/caching_functions';

// Main saga function with proper return type
export function* sagaGetCategoriesMinimalList(): Generator<any, void, any> {
  // Generator function to handle category fetching
  function* getCategories(action: {
    type: string;
    payload: {
      success?: (minimalCategoriesList: AbstractCategory[]) => void;
      error?: () => void;
    };
  }): Generator<any, any, any> {
    const payload: any = {};

    // Get the current state of categories from the Redux store
    const state = yield select((state: any) => state.CategoriesBase);
    const { minimalCategoriesList, lastFetchedMinimalCategories } = state;
    if (
      minimalCategoriesList?.length > 0 &&
      lastFetchedMinimalCategories &&
      !shouldRefreshCache(
        GET_CATEGORIES_MINIMALIST,
        lastFetchedMinimalCategories,
      )
    ) {
      // If the cache is valid, return the cached categories
      yield put(
        actionGetCategoriesMinimalListSuccess({
          categories: minimalCategoriesList,
        }),
      );
      action?.payload?.success && action.payload.success(minimalCategoriesList);
      return;
    }

    // Fetch the categories if cache is outdated or empty
    const res: AbstractCategory[] = yield call(
      SharedRepository.getCategoriesAsList,
    );
    if (!res) {
      action?.payload?.error && action.payload.error();
      return false;
    }

    payload.categories = res;
    yield put(actionGetCategoriesMinimalListSuccess(payload));
    action?.payload?.success && action.payload.success(res);
  }
  yield takeLatest(GET_CATEGORIES_MINIMALIST, getCategories);
}
